(function (window, $j) {

    function onDocReady() {
        $j(".testimonials-section .more-testimonials-button").click(testimonialsToggle);
    }
    
    function testimonialsToggle() {
        if($j(this).closest(".testimonials-container").hasClass("show-more")) {
            $j(this).closest(".testimonials-container").find(".more-testimonials").slideUp();
            $j(this).closest(".testimonials-container").removeClass("show-more");
            $j(this).html($j(this).attr("data-open-button"));
        }
        else {
            $j(this).closest(".testimonials-container").find(".more-testimonials").slideDown();
            $j(this).closest(".testimonials-container").addClass("show-more");
            $j(this).html($j(this).attr("data-close-button"));
        }
    }

    $j(onDocReady);

    return {};

})(window,$j);
